export enum NoteOperatorEnums {
  credit = -1,
  debit = 1
}